import { render, staticRenderFns } from "./BasicExamVoiceCommandDisplay.vue?vue&type=template&id=1b4f0a6d&scoped=true"
import script from "./BasicExamVoiceCommandDisplay.vue?vue&type=script&lang=js"
export * from "./BasicExamVoiceCommandDisplay.vue?vue&type=script&lang=js"
import style0 from "./BasicExamVoiceCommandDisplay.vue?vue&type=style&index=0&id=1b4f0a6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f0a6d",
  null
  
)

export default component.exports